import { render, staticRenderFns } from "./UploadModalV2.vue?vue&type=template&id=2d67f85c&scoped=true"
import script from "./UploadModalV2.vue?vue&type=script&lang=js"
export * from "./UploadModalV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d67f85c",
  null
  
)

export default component.exports